export const openUrlInNewWindow = (url) => window.open(url);
export const getOffsetHeight = (element) => element.offsetHeight;
